/**
 * POST /auth/refresh - Refresh access token
 */

import type { ActionDefinition } from '@gzl10/nexus-sdk'
import type { MiddlewareHandler } from 'hono'
import { getCookie, setCookie } from 'hono/cookie'
import type { AuthService } from '../auth.service.js'
import type { AuthConfig } from '../auth.types.js'
import { getCookieOptions, getRequestInfo } from './helpers.js'

export const refreshAction: ActionDefinition = {
  key: 'refresh',
  label: { en: 'Refresh Token', es: 'Refrescar token' },
  icon: 'mdi:refresh',
  scope: 'module',
  hidden: true,
  method: 'POST',
  skipAuth: true,
  middleware: (ctx) => (ctx.services.get('authRateLimits') as { refresh: MiddlewareHandler }).refresh,
  input: {
    refreshToken: { input: 'text', label: { en: 'Refresh Token', es: 'Token de refresco' } }
  },
  handler: async (ctx, input, c) => {
    const body = input as { refreshToken?: string }
    const cookieToken = c ? getCookie(c, 'refreshToken') : undefined
    const refreshToken = cookieToken ?? body.refreshToken
    if (!refreshToken) {
      throw new ctx.core.errors.UnauthorizedError('Refresh token required')
    }

    const authService = ctx.services.get<AuthService>('auth')
    const authCfg = ctx.services.get<AuthConfig>('authConfig')
    const result = await authService.refresh(refreshToken, getRequestInfo(c))

    if (c) setCookie(c, 'refreshToken', result.refreshToken, getCookieOptions(c, authCfg.cookieDomain))

    return {
      accessToken: result.accessToken,
      abilities: result.abilities
    }
  }
}
